/* generated using generate-extended-services -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {AxiosHttpRequest} from './core/AxiosHttpRequest';
import {BaseHttpRequest} from './core/BaseHttpRequest';
import {OpenAPIConfig} from './core/OpenAPI';
import {UsageStatsServiceExtended} from './extendedServices/UsageStatsServiceExtended';
import {EntitlementsApiService} from './EntitlementsApiService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class EntitlementsApiServiceExtended extends EntitlementsApiService {
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest,
  ) {
    super(config, HttpRequest);
    (this as any).usageStats = new UsageStatsServiceExtended(this.request);
  }
}
